// extracted by mini-css-extract-plugin
export default {"wrapper":"OTPCode_wrapper__XVwVv"};